import React from 'react';
import { Button, Input, Grid } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import ReadCookie from '../../functions/readcookies';
import Brand from '../dropdown/brand';

class AddSpare extends React.Component {

  state = {
    dialog: false, maxWidth: 'sm', fullWidth: true,
    brand: '', mrp: '', dnp: '', point: '',
    life: '', weight: '', min_order_qty: ''
  }

  handleClose = () => { this.setState({ dialog: false }) }

  texthandle = (type) => event => { this.setState({ [type]: event.target.value }) }

  submit() {
    let context = this;
    if (!this.state.partno) { alert('Enter the partno'); return; }
    if (!this.state.sparename) { alert('Enter the sparename'); return; }
    if (!this.state.tax) { alert('Enter the tax'); return; }
    if (!this.state.hsncode) { alert('Enter the hsncode'); return; }
    if (!this.state.mrp) { alert('Enter the MRP'); return; }
    if (!this.state.dnp) { alert('Enter the DNP'); return; }

    let tax = this.state.tax;
    let dnp = this.state.dnp;
    let mrp = this.state.mrp;
    let point = this.state.point;
    let life = this.state.life;
    let weight = this.state.weight;
    let min_order_qty = this.state.min_order_qty;
    if (tax < 10) {
      tax = '1.0'+tax;
    }
    else {
      tax = '1.'+tax;
    }
    if (point == undefined || point == null || point == '') {
      point = 0;
    }
    if (life == undefined || life == null || life == '') {
      life = 0;
    }
    if (weight == undefined || weight == null || weight == '') {
      weight = 0;
    }
    if (min_order_qty == undefined || min_order_qty == null || min_order_qty == '') {
      min_order_qty = 0;
    }
    tax = Number(tax);
    mrp = Number(mrp/tax).toFixed(2);
    dnp = Number(dnp/tax).toFixed(2);
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'partno': this.state.partno, 'sparename': this.state.sparename,
              'hsncode': this.state.hsncode, 'tax': this.state.tax,
              'mrp': mrp, 'dnp': dnp, 'by': by, 'brand': this.state.brand,
              'point': point, 'life': life, 'weight': weight, 'min_order_qty': min_order_qty},
      url: Server() + 'spares/addnewspare.php',
      success: function(data) {
        console.log(data);
        console.log('koooooooooooooooooo');
        if (data == 1) {
          alert('Success');
          context.props.getAllSpareDetails(1, 'partno', 'asc');
          context.props.getData(context.state.partno, context.state.sparename, context.state.tax);
          context.setState({ dialog: false, partno: '', sparename: '', hsncode: '', tax: '', dnp: '', mrp: '', load: false, });
        } else {
          alert('Failed');
          context.setState({ load: false, });
        }
      },
      error: function(error) {
        context.setState({ load: false, });
      }
    });
  }

  update(value, allBrands) {
    this.setState({ brand: value, allBrands: allBrands })
  }

  render() {
    return (
      <div>
        <Button onClick={ () => {
          if (!this.props.menuPermission.add) {
            alert('You Are Not Alllow To Add Spares!!!');
            return;
          } 
          this.setState({ dialog: true }) 
          }}>NEW</Button>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.dialog}
          onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Add Spare</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('partno')} placeholder='partno' value={this.state.partno} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('sparename')} placeholder='Spare Name' value={this.state.sparename} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('tax')} placeholder='tax' value={this.state.tax} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('hsncode')} placeholder='HSN CODE' value={this.state.hsncode} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('dnp')} placeholder='DNP' value={this.state.dnp} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('mrp')} placeholder='MRP' value={this.state.mrp} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('point')} placeholder='POINT' value={this.state.point} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('life')} placeholder='LIFE' value={this.state.life} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('weight')} placeholder='WEIGHT' value={this.state.weight} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Input onChange={this.texthandle('min_order_qty')} placeholder='MINIMUM ORDER QTY' value={this.state.min_order_qty} type='number' fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Brand update={this.update.bind(this)} type={'none'} />
                </Grid.Column>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)}>Submit</Button>
            <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddSpare;
